<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { submitDbid = item.dbid; submitMsg = item.name; submit = true; }"
                 :disabled="pubDisna"
          >
            <v-icon color="green darken-2">publish</v-icon>
          </v-btn>
          <span>发布申报</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="startReciving = true;curReviewId = item.dbid;"
                 :disabled="recDisna"
          >
            <v-icon color="primary" >check_circle</v-icon>
          </v-btn>
          <span>开启接收</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 :disabled="closeDisna"
                 @click="closeReciving = true;curReviewId = item.dbid;"
          >
            <v-icon color="red" >remove_circle</v-icon>
          </v-btn>
          <span>关闭接收</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { startReviewDbid = item.dbid; startReviewMsg = item.name; startReview = true; }"
                 :disabled="reviewDisna"
          >
            <v-icon color="blue darken-2" >chat</v-icon>
          </v-btn>
          <span>开启评审</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="closeReview = true;curReviewId = item.dbid;"
                 :disabled="closeReviewDisna"
          >
            <v-icon color="orange darken-2" >present_to_all</v-icon>
          </v-btn>
          <span>关闭评审</span>
        </v-tooltip>

        <v-tooltip top>
          <v-chip small label class="mx-0" slot="activator"
                  :color="item.status.color"
                  @click="() => { history=item.history; hist = true; }">
            {{ item.status.name }}
          </v-chip>
          <span>点击查看审核历史</span>
        </v-tooltip>

        <PubReview
            v-model="submit"
            :dbid="submitDbid"
            :message="submitMsg"
            :uri="uri"
            :startdate="startdate"
            :enddate="enddate"
            @ok="handlePubOk"
            @reset="onPubOK"
        />

        <StartReview
            v-model="startReview"
            :dbid="startReviewDbid"
            :message="startReviewMsg"
            :recenddate="recenddate"
            :expert-count="expertCount"
            :uri="uri"
            @ok="(it) => Object.assign(item,it)"
            @reset="onStartReview"
        />

        <x-history
            v-model="hist"
            :history="history"
            :status="statusItems"
        />
      </v-flex>

      <v-flex xs12>
        <basic :review="item"/>
      </v-flex>

      <v-flex d-flex xs12 sm12 md12 lg7>
        <v-layout row wrap>
          <v-flex xs12 d-flex>
            <expert :review="item"/>
          </v-flex>

          <v-flex xs12 d-flex>
            <attachment :review="item"/>
          </v-flex>

        </v-layout>
      </v-flex>

      <v-flex d-flex xs12 sm12 md12 lg5>
        <v-layout row wrap>
          <v-flex xs12 d-flex>
            <review-template :review="item"/>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <DeclareProj :reviewId="item"/>
      </v-flex>

      <v-dialog
          scrollable
          v-model="startReciving"
          max-width="500px"
          :persistent="true"
      >
        <v-card>
          <v-card-title class="subheading">
            确认开启项目申报接收
          </v-card-title>
          <v-divider/>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 sm12 lg12>
               <v-label>
                   开启接收后，申报的状态变为接收，教师可以对此申报提交项目申请资料！
               </v-label>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" @click.native= "startReciving = false">
              <v-icon dark >cancel</v-icon>取消
            </v-btn>
            <v-btn color="primary" @click.native="onReciving">
              <v-icon dark >link</v-icon>开启接收
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
          scrollable
          v-model="closeReciving"
          max-width="500px"
          :persistent="true"
      >
        <v-card>
          <v-card-title class="subheading">
            确认关闭项目申报接收
          </v-card-title>
          <v-divider/>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 sm12 lg12>
                  <v-label>
                    关闭接收后，申报状态变为停止接收，申报不再接收教师提交项目申报资料！
                  </v-label>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" @click.native= "closeReciving = false">
              <v-icon dark >cancel</v-icon>取消
            </v-btn>
            <v-btn color="primary" @click.native="onClose">
              <v-icon dark >block</v-icon>关闭接收
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
          scrollable
          v-model="closeReview"
          max-width="500px"
          :persistent="true"
      >
        <v-card>
          <v-card-title class="subheading">
            确认关闭项目评审
          </v-card-title>
          <v-divider/>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 sm12 lg12>
                  <v-label>
                    关闭评审后，申报的状态变为评审结束，专家不可以再对申报项目进行评审，申报管理人员可查看评审结果，并进行立项处理！
                  </v-label>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" @click.native= "closeReview = false">取消</v-btn>
            <v-btn color="primary" @click.native="onCloseReview">关闭评审</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

import Basic from '@/components/proj/review/Basic'
import ReviewTemplate from "@/components/proj/review/ReviewTemplate";
import Expert from "@/components/proj/review/Expert/Expert";
import Attachment from "@/components/proj/review/Attachment";
import PubReview from "@/components/proj/review/PubReview";
import Vue from "vue";
import XHistory from "@/components/global/History";
import DeclareProj from "@/components/proj/review/DeclareProj";
import StartReview from "@/components/proj/review/StartReview";
const baseUri = '/api/proj/review';
const statusUri = '/api/proj/status';
export default {
  name: "Manage",
  components: {Basic,Expert,Attachment,PubReview, XHistory, DeclareProj, ReviewTemplate, StartReview},
  data: () => ({
    uri: baseUri,

    item: {
      status: {},
    },

    form: {
      name: '',
      reviewStart: '',
      reviewEnd: '',
      reviewStatusId: ''
    },

    query: {
      page: 1,
      rowsPerPage: 25,
      sortBy: 'rkrq',
      descending: true,
      totalItems: null
    },

    submit: false,
    submitDbid: null,
    submitMsg: null,

    startReview: false,
    startReviewDbid: null,
    startReviewMsg: null,

    closeReview: false,
    closeReviewDbid: null,
    closeReviewMsg: null,

    review: false,
    reviewDbid: null,
    reviewMsg: null,

    statusItems: [],

    receiveStatus: [],

    startReciving: false,
    curReviewId: '',

    closeReciving: false,

    startdate : '',
    enddate : '',
    recenddate : '',
    expertCount : 0,

    hist: false,
    history: [],

    pubDisna: false,
    recDisna: false,
    closeDisna: false,
    reviewDisna: false,
    closeReviewDisna: false,
  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    const dbid = to.params.dbid;
    if (dbid) {
      //获取基本信息
      Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
              rsp => next(vm => {
                vm.dbid = dbid;
                vm.item = rsp.data;
                window.console.log("vm.item")
                window.console.log(vm.item)
                if(vm.item.experts)
                  vm.expertCount = vm.item.experts.length
                vm.startdate = vm.item.startDate
                vm.enddate = vm.item.finishDate
                vm.recenddate = vm.item.receiveEndDate
                if (vm.item.actions.find(a => a.action === 'pub'))
                {
                  vm.recDisna = true
                  vm.pubDisna = false
                  vm.closeDisna = true
                  vm.reviewDisna = true
                  vm.closeReviewDisna = true
                }
                if (vm.item.actions.find(a => a.action === 'rec'))
                {
                  vm.recDisna = false
                  vm.pubDisna = true
                  vm.closeDisna = true
                  vm.reviewDisna = true
                  vm.closeReviewDisna = true
                }
                if (vm.item.actions.find(a => a.action === 'close'))
                {
                  vm.recDisna = true
                  vm.pubDisna = true
                  vm.closeDisna = false
                  vm.reviewDisna = true
                  vm.closeReviewDisna = true
                }
                if (vm.item.actions.find(a => a.action === 'review'))
                {
                  vm.recDisna = true
                  vm.pubDisna = true
                  vm.closeDisna = true
                  vm.reviewDisna = false
                  vm.closeReviewDisna = true
                }
                if (vm.item.actions.find(a => a.action === 'fin'))
                {
                  vm.recDisna = true
                  vm.pubDisna = true
                  vm.closeDisna = true
                  vm.reviewDisna = true
                  vm.closeReviewDisna = false
                }
                if (vm.item.actions.find(a => a.action === 'finback'))
                {
                  vm.recDisna = true
                  vm.pubDisna = true
                  vm.closeDisna = true
                  vm.reviewDisna = true
                  vm.closeReviewDisna = true
                }
                // 保存默认数据
                vm.defaultItem = window.xutil.clone(vm.item);
                vm.loading = false
              })
          )

    } else {
      next();
    }
  },

  // 路由改变前，组件就已经渲染完成，可以使用 this
  beforeRouteUpdate(to, from, next) {

    const dbid = to.params.dbid;

    if (dbid) {
      //this.loading = true;
      Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
              rsp => {
                this.dbid = dbid;
                this.item = rsp.data;
                // 保存默认数据
                this.defaultItem = window.xutil.clone(this.item);
                this.loading = false;
                next()
              }
          )
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters(['funcIds'])
  },


  created() {
    let t = 'review'
    // 加载审核状态
    this.axios.get(`${statusUri}/${t}`, {params: {sort: 'rank.asc'}})
        .then(
            rspStatus => {
              this.statusItems = rspStatus.data;
            }
        )
  },

  methods: {
    onReciving() {
      //this.loading = true;
      this.axios.put(`${baseUri}/rec/${this.curReviewId}`)
          .then(rsp => {
               this.receiveStatus = rsp.data.items
               this.startReciving = false
               this.recDisna = true
               this.closeDisna = false
               this.item.status.color = "green"
               this.item.status.name = "接收中"
               this.loading = false;
          });
    },

    onClose() {
      this.axios.put(`${baseUri}/close/${this.curReviewId}`)
          .then(rsp => {
            this.receiveStatus = rsp.data.items
            this.closeReciving = false
            this.closeDisna = true
            this.reviewDisna = false
            this.item.status.color = "yellow"
            this.item.status.name = "停止申报"
          });
    },

    onCloseReview() {
      this.axios.put(`${baseUri}/fin/${this.curReviewId}`)
          .then(rsp => {
            this.receiveStatus = rsp.data.items
            this.closeReview = false
            this.closeReviewDisna = true
            this.item.status.color = "orange"
            this.item.status.name = "评审结束"
          });
    },

    onPubOK() {
      this.pubDisna = true
      this.recDisna = false
      this.item.status.color = "blue"
      this.item.status.name = "已发布"
    },

    handlePubOk(it) {
      window.console.log("it")
      window.console.log(it)
      //Object.assign(this.item, it);
      window.console.log(this.item)
      //后续代码在于当子组件PubReview更新数据并返回后对所有子组件动态新增数据的自动刷新显示，若如这个机制，页面不会动态显示更新的数据
      Object.keys(it).forEach(key => {
      Vue.set(this.item, key, it[key]); // 确保新属性是响应式的
      });
    },

    onStartReview() {
      this.reviewDisna = true
      this.closeReviewDisna = false
      this.item.status.color = "lime"
      this.item.status.name = "评审中"
    }

  },

}
</script>

<style scoped>

</style>